export enum Color {
  WHITE = "White",
  BLACK = "Black",
}
export enum PieceNames {
  PIECE = "PIECE",
  KING = "KING",
  KNIGHT = "KNIGHT",
  PAWN = "PAWN",
  QUEEN = "QUEEN",
  ROOK = "ROOK",
  BISHOP = "BISHOP",
}
export enum PieceIcons {
  PIECE = "",
  KING = "♚",
  KNIGHT = "♞",
  PAWN = "♟︎",
  QUEEN = "♛",
  ROOK = "♜",
  BISHOP = "♝",
}
